import ucwords from './ucwords';

const getBreadcrumb = (router: any) => {
	const asPath = router?.asPath.split('/');
	const pathname = router?.pathname;

	asPath?.shift();
	if (pathname.indexOf('/[action]/[uid]') !== -1) {
		asPath?.pop();
	}

	return asPath?.map((r: any, index: number) => {
		let test = r.split('?')[0];
		let breadcrumbName = ucwords(test.split('#')[0]);
		if (pathname.indexOf('/[uid]') !== -1) {
			if (index + 1 === asPath.length) {
				breadcrumbName = r.split('#')[0];
			}
		}
		return {
			path: '/'+r,
			breadcrumbName: breadcrumbName,
		};
	});
};

export { getBreadcrumb };
